import { css } from 'wiloke-react-core';

export const container = css`
  padding: 0 15px;
`;
